import { t } from '@lingui/core/macro';

import type {
  KPINotificationType,
  PageMetaNotificationNameType,
} from '@/api/settings/settingsType';

type VendorKPINameType =
  | 'web-traffic-total-visits'
  | 'web-traffic-target-visits'
  | 'web-traffic-engaged-companies'
  | 'web-traffic-pipeline-influenced'
  | 'web-traffic-closed-won-influenced';

export const vendorGoalKPIs = (): Partial<
  Record<PageMetaNotificationNameType, KPINotificationType<VendorKPINameType>[]>
> => ({
  vendor: [
    { value: 'web-traffic-total-visits', label: t`Total Visits`, allowsAudience: false },
    {
      value: 'web-traffic-target-visits',
      label: t`Audience Visits`,
      allowsAudience: true,
    },
    {
      value: 'web-traffic-engaged-companies',
      label: t`Audience Engaged Companies`,
      allowsAudience: true,
    },
    {
      value: 'web-traffic-pipeline-influenced',
      label: t`Audience Pipeline Influence`,
      allowsAudience: true,
    },
    {
      value: 'web-traffic-closed-won-influenced',
      label: t`Audience Closed Won Influence`,
      allowsAudience: true,
    },
  ],
  vendors: [
    { value: 'web-traffic-total-visits', label: t`Total Visits`, allowsAudience: false },
    {
      value: 'web-traffic-target-visits',
      label: t`Audience Visits`,
      allowsAudience: true,
    },
    {
      value: 'web-traffic-engaged-companies',
      label: t`Audience Engaged Companies`,
      allowsAudience: true,
    },
    {
      value: 'web-traffic-pipeline-influenced',
      label: t`Audience Pipeline Influence`,
      allowsAudience: true,
    },
    {
      value: 'web-traffic-closed-won-influenced',
      label: t`Audience Closed Won Influence`,
      allowsAudience: true,
    },
  ],
});
